(function () {
    function shuffleSection(id, limit) {
      var section = document.getElementById(id);
      if (!section) return;

      var grid = section.querySelector('.hdt-collection-products');
      if (!grid) return;

      var items = Array.from(grid.children);
      if (items.length < 2) return;

      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        grid.insertBefore(items[j], items[i]);
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }

      if (limit) {
        Array.from(grid.children).forEach(function (item, index) {
          if (index >= limit) item.style.display = 'none';
        });
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      shuffleSection('shopify-section-template--20824034705653__featured_collection_46WUWB');
      shuffleSection('shopify-section-template--20824034705653__featured_collection_PTq36A', 4);
      shuffleSection('shopify-section-template--20824034705653__featured_collection_ck9xND', 4);
    });
  })();